import { useCallback, useEffect, useState } from "react";
import { Button, Result } from "antd";
import ClearCacheGuide from "components/ClearCacheGuide";
import { isChunkLoadError } from "utils/sentry";
import {
  recoverFromChunkError,
  resetChunkRecoveryAttempts,
} from "utils/chunkRecovery";

// eslint-disable-next-line react/prop-types
export default function ChunkErrorFallback({ error, resetError }) {
  // Pemulihan (bersihkan SW + cache rusak lalu reload) ada di utils/chunkRecovery,
  // sudah dibatasi jumlah percobaannya per tab.
  const [gaveUp, setGaveUp] = useState(false);
  const doReload = useCallback(
    (source) => {
      setGaveUp(false);
      return recoverFromChunkError(error, source).then((reloading) => {
        if (!reloading) setGaveUp(true);
      });
    },
    [error],
  );

  useEffect(() => {
    if (isChunkLoadError(error)) doReload("error_boundary");
  }, [error, doReload]);

  if (isChunkLoadError(error)) {
    return (
      <Result
        status="500"
        title="Aplikasi baru telah dirilis"
        subTitle={
          navigator.onLine
            ? "Kami perlu memuat ulang halaman agar Anda mendapat versi terbaru. Jika tidak berhasil dalam beberapa kali percobaan, silakan klik Coba Lagi."
            : "Anda sedang offline. Sambungkan internet lalu klik Coba Lagi untuk memuat ulang aplikasi."
        }
        extra={[
          <Button
            type="primary"
            key="manual-reload"
            onClick={() => {
              resetChunkRecoveryAttempts();
              doReload("manual_retry");
            }}
          >
            Coba Lagi
          </Button>,
          <Button
            key="reset"
            onClick={() => {
              resetChunkRecoveryAttempts();
              resetError();
            }}
          >
            Reset
          </Button>,
        ]}
      >
        {gaveUp && navigator.onLine && <ClearCacheGuide buttonLabel="Coba Lagi" />}
      </Result>
    );
  }

  // fallback umum non-chunk
  return (
    <Result
      status="500"
      title="Maaf, Terjadi masalah pada aplikasi CRM.ID!"
      subTitle="Silakan klik Reload untuk memuat ulang halaman, atau Reset untuk mencoba lagi."
      extra={[
        <Button
          type="primary"
          key="reload"
          onClick={() => window.location.reload()}
        >
          Reload
        </Button>,
        <Button key="reset" onClick={resetError}>
          Reset
        </Button>,
      ]}
    />
  );
}
